<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxPager, DxRemoteOperations,
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Base para Cotação de Frete TDE",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    DxFilterRow,
    DxColumn,
    DxRemoteOperations,
    DxPager,
    DxDataGrid,
    Layout, PageHeader, Loader, Multiselect  },
  setup() {

  },
  data() {
    return {
      updating: true,
      errosValid: null,
      freteCotaBaseTdeData: {
        id: 0,
        status: 'A'
      },
      freteCotaBaseTranspsData: null,
      freteCotaBaseTranspData: {},
      freteCotaBaseDestsData: null,
      freteCotaBaseDestData: {},
      freteCotaBaseBasesData: null,
      freteCotaBaseBaseData: {},
      
      idData: 0,
      submitted: false,
      submittedTransp: false,
      submittedDest: false,
      submittedBase: false,
      
      title: "Base para Cotação de Frete TDE",
      items: [
        {
          text: "Bases Cotação TDE",
          href: "/cotacaofretesbasetde/list",
        },
        {
          text: "Base para Cotação de Frete TDE",
          active: true,
        },
      ],
      showFormTransp: false,
      showFormDest: false,
      showFormBase: false,
      dtListPesqBase: null,
    };
  },

  methods: {


    pesqBase(evt){
      console.log('pesqBase')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/fretecotabasepesq`, {
          params: { q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqBase = res.data
        })
      }
    },


    onRowDblClickDest(row){
      console.log('onRowDblClickDest')
      this.freteCotaBaseDestData = row.data
      this.showFormDest = true
    },

    onRowDblClickBase(row){
      console.log('onRowDblClickBase')
      this.freteCotaBaseBaseData = row.data
      this.showFormBase = true
    },

    confDest() {
      console.log('confDest')
      this.submittedDest = true
      if (this.freteCotaBaseDestData.cnpj && this.freteCotaBaseDestData.nome){
        this.showFormDest = false
        this.updating = true
        this.freteCotaBaseDestData['fretecotabasetde_id'] = this.idData
        api.post(`${getBaseUrl()}api/fretecotabasetdedest`, {
          freteCotaBaseDestData: this.freteCotaBaseDestData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.updating = false
            this.carregarDados()
          })
        })
      }
    },

    confBase() {
      console.log('confbase')
      this.submittedBase = true
      if (this.freteCotaBaseBaseData.fretecotabase_id){
        this.showFormBase = false
        this.updating = true
        this.freteCotaBaseBaseData['fretecotabasetde_id'] = this.idData
        api.post(`${getBaseUrl()}api/fretecotabasetdebase`, {
          freteCotaBaseBaseData: this.freteCotaBaseBaseData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.updating = false
            this.carregarDados()
          })
        })
      }
    },

    novoDestinatario(){
      console.log('novoDestinatario')
      this.freteCotaBaseDestData = {}
      this.submittedDest = false
      this.showFormDest = true
    },

    novaBase(){
      console.log('novaBase')
      this.freteCotaBaseBaseData = {}
      this.submittedBase = false
      this.showFormBase = true
    },

    deletarDest(){
      console.log('deletarDest')
      this.showFormDest = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Destinatário",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasetdedest`, {
            params: {
              'iddata': this.freteCotaBaseDestData.id
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })
    },

    deletarBase(){
      console.log('deletarBase')
      this.showFormBase = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Base",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasetdebase`, {
            params: {
              'iddata': this.freteCotaBaseBaseData.id
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })
    },

    deletarTde(){
      console.log('deletarTde')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de TDE",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasetde`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.$router.push(`/cotacaofretesbasetde/list`)
            })
          })
        }
      })
    },



    carregarDados(){
      this.updating = true
      api.get(`${getBaseUrl()}api/fretecotabasetde`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios cotaFreteBase')
        console.log(res.data)
        this.freteCotaBaseTdeData = res.data[0]
        this.freteCotaBaseTranspsData = res.data[1]
        this.freteCotaBaseBasesData = res.data[2]

        this.idData = this.freteCotaBaseTdeData.id
        this.title = `Editar Base de Cotação TDE (${this.freteCotaBaseTdeData.id}) ${this.freteCotaBaseTdeData.descricao}`
        this.updating = false

        const idbase = this.idData

        this.freteCotaBaseDestsData = new CustomStore({
          key: "id",
          load: function(loadOptions){
            let queryArray = []
            if (loadOptions['filter']) {
              if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
                loadOptions['filter'].forEach((value) => {
                  // console.log('value_filter')
                  // console.log(value)
                  // console.log(value[0])
                  // console.log(typeof (value))
                  if (typeof (value) === "object") {
                    queryArray.push({
                      cmp: value[0],
                      opr: value[1],
                      val: value[2],
                    })
                  }
                })
              } else {
                queryArray.push({
                  cmp: loadOptions['filter'][0],
                  opr: loadOptions['filter'][1],
                  val: loadOptions['filter'][2],
                })
              }
            }
            const paramsReq = {
              'skip': loadOptions['skip'],
              'take': loadOptions['take'],
              'filter': queryArray,
              'sort': loadOptions['sort'],
              'idbase': idbase
            }
            // console.log('paramsReq')
            // console.log(paramsReq)
            return api.get(`${getBaseUrl()}api/fretecotabasetdedests`, {
              params: paramsReq
            }).then(response => {
              console.log('response.data')
              console.log(response)
              return {
                data: response.data[0],
                totalCount: response.data[1],
              }
            })
          },
        })

      });
    },


    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;

      if (this.freteCotaBaseTdeData.id === 0) {
        console.log('vai_criar_tabela')
        this.freteCotaBaseTdeData.fretecotabasetab_id = this.$route.query.idtab
      }

      if (this.freteCotaBaseTdeData.descricao) {
        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/fretecotabasetde`, {
          freteCotaBaseTdeData: this.freteCotaBaseTdeData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          if (this.idData === 0){
            this.idData = res.data[0].id
            this.freteCotaBaseTdeData = res.data[0]
            this.$router.replace('/cotacaofretesbasetde/editar/' + this.idData)
            this.title = `Editar Base de Cotação TDE (${this.freteCotaBaseTdeData.id}) ${this.freteCotaBaseTdeData.descricao}`
          }
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },



    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },


  mounted() {
    console.log('mounted_user_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Nova Base para Cotação de Frete TDE`
      this.updating = false
    }
  },


};

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="freteCotaBaseTdeData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-success" class="mx-2" @click="formSubmit">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="deletarTde" v-if="idData > 0">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Excluir
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novoDestinatario" v-if="idData > 0">
                <i class="bx bx-box font-size-16 align-middle me-2" ></i>
                Novo Destinatário
              </b-button>

<!--              <b-button variant="outline-warning" class="mx-2" @click="novaBase" v-if="idData > 0">-->
<!--                <i class="bx bx-box font-size-16 align-middle me-2" ></i>-->
<!--                Nova Base-->
<!--              </b-button>-->


            </div>
          </div>
        </div>
      </div>


      <form class="needs-validation" @submit.prevent="formSubmit">
        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a
                    v-b-toggle.accordion-4
                    class="text-dark"
                    href="javascript: void(0);"
                >Dados Principais</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
              <b-card-body>



                <div class="row mb-2">

                  <div class="col-md-9">
                    <label for="descricao">Descrição</label>
                    <div class="position-relative">
                      <input
                          id="descricao"
                          type="text"
                          v-model="freteCotaBaseTdeData.descricao"
                          class="form-control"
                          placeholder="Descrição"
                          :class="{'is-invalid': submitted && !freteCotaBaseTdeData.descricao}"/>
                      <div v-if="submitted && !freteCotaBaseTdeData.descricao" class="invalid-feedback">
                        <span>Campo Descrição obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="mb-3">
                      <label for="statuscont">Status</label>
                      <select
                          id="statuscont"
                          v-model="freteCotaBaseTdeData.status"
                          class="form-control">
                        <option value="A">Ativo</option>
                        <option value="I">Inativo</option>
                      </select>
                    </div>
                  </div>

                </div>


                <div class="row mb-2">

                  <div class="col-md-3">
                    <label for="tdeperc">TDE (%)</label>
                    <div class="position-relative">
                      <input
                          id="tdeperc"
                          type="number"
                          v-model="freteCotaBaseTdeData.tdeperc"
                          class="form-control text-end"
                          placeholder="TDE (%)"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="tdemin">TDE Valor Mínimo</label>
                    <div class="position-relative">
                      <input
                          id="tdemin"
                          type="number"
                          v-model="freteCotaBaseTdeData.tdemin"
                          class="form-control text-end"
                          placeholder="TDE Valor Mínimo"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="tdemax">TDE Valor Máximo</label>
                    <div class="position-relative">
                      <input
                          id="tdemax"
                          type="number"
                          v-model="freteCotaBaseTdeData.tdemax"
                          class="form-control text-end"
                          placeholder="TDE Valor Máximo"/>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label for="tdefixo">TDE Valor Fixo</label>
                    <div class="position-relative">
                      <input
                          id="tdefixo"
                          type="number"
                          v-model="freteCotaBaseTdeData.tdefixo"
                          class="form-control text-end"
                          placeholder="TDE Valor Fixo"/>
                    </div>
                  </div>

                </div>

              </b-card-body>

            </b-collapse>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a v-b-toggle.accordion-5
                   class="text-dark"
                   href="javascript: void(0);">Destinatário(s)</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
              <b-card-body>
                  <DxDataGrid
                      ref="dataGridRefKeyDest"
                      :data-source="freteCotaBaseDestsData"
                      :show-borders="true"
                      :column-auto-width="true"
                      :show-row-lines="true"
                      :allow-column-reordering="true"
                      :allow-column-resizing="true"
                      :row-alternation-enabled="true"
                      @row-dbl-click="onRowDblClickDest">
                    <DxRemoteOperations
                        :filtering="true"
                        :paging="true"
                        :sorting="true"
                        :summary="true"
                        :grouping="false"
                        :group-paging="false"/>
                    <DxFilterRow :visible="true"/>
                    <DxColumn
                        data-field="id"
                        sort-order="desc"
                        caption="ID"
                        data-type="number"
                        alignment="right"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="true"/>
                    <DxColumn
                        data-field="cnpj"
                        caption="CNPJ"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                        :allowHeaderFiltering="true"/>
                    <DxColumn
                        data-field="nome"
                        caption="Nome"
                        alignment="left"
                        data-type="text"
                        :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                        :allowHeaderFiltering="true"/>
                    <DxColumn
                        data-field="created_at"
                        caption="Criado"
                        alignment="right"
                        data-type="datetime"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="true"/>
                    <DxPager
                        :visible="true"
                        :show-page-size-selector="true"
                        :allowed-page-sizes="[10, 30, 50, 100]"
                        :show-navigation-buttons="true"
                        :show-info="true"/>
                  </DxDataGrid>
              </b-card-body>
            </b-collapse>
          </div>
        </div>


      </form>

    </div>




    <b-modal  size="lg"
              :title="freteCotaBaseDestData.id > 0 ? 'Editando Destinatário ' + freteCotaBaseDestData.id : 'Criando Destinatário'"
              v-model="showFormDest" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">
            <form class="needs-validation">
              <div class="row mb-3">

                <div class="col-md-4">
                  <label for="cnpj">CNPJ</label>
                  <div class="position-relative">
                    <input
                        id="cnpj"
                        type="text"
                        v-model="freteCotaBaseDestData.cnpj"
                        class="form-control text-end"
                        :class="{'is-invalid': submittedTransp && !freteCotaBaseDestData.cnpj}"
                        placeholder="CNPJ"/>
                    <div v-if="submittedTransp && !freteCotaBaseTdeData.cnpj" class="invalid-feedback">
                      <span>Campo CNPJ obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-8">
                  <label for="nome">Nome</label>
                  <div class="position-relative">
                    <input
                        id="nome"
                        type="text"
                        v-model="freteCotaBaseDestData.nome"
                        class="form-control text-end"
                        :class="{'is-invalid': submittedTransp && !freteCotaBaseDestData.nome}"
                        placeholder="Nome"/>
                    <div v-if="submittedTransp && !freteCotaBaseTdeData.nome" class="invalid-feedback">
                      <span>Campo Nome obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormDest = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>

                  <b-button variant="outline-danger"
                            v-if="freteCotaBaseDestData.id > 0"
                            @click="deletarDest" >
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Excluir
                  </b-button>

                  <b-button type="button" variant="success" class="ms-1" @click="confDest">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>




    <b-modal  size="lg"
              :title="freteCotaBaseBaseData.id > 0 ? 'Editando Associação Base x TDE ' + freteCotaBaseBaseData.id : 'Criando Associação Base x TDE'"
              v-model="showFormBase" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">
            <form class="needs-validation">
              <div class="row mb-3">


                <div class="col-md-12">
                  <div class="mb-3">
                    <span>Base</span>
                    <multiselect id="fretecotabase"
                                 class="mt-2"
                                 @search-change="pesqBase"
                                 v-model="freteCotaBaseBaseData.fretecotabase_id"
                                 placeholder="Pesquisar bases"
                                 :options="dtListPesqBase"
                                 :searchable="true"
                                 label="descricao"
                                 track-by="descricao"
                                 :style="submittedBase && !freteCotaBaseBaseData.fretecotabase_id ? 'border: 1px solid #f86c6b !important;' : ''"
                                 value-prop="id">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                          <span class="text-info">
                            {{ slotProps.option.id }}
                          </span>
                            <span class="mx-4" >
                          </span>
                          </div>
                          <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                          <span class="mx-4">{{ slotProps.option.transpnome }}</span>
                          <span class="mx-4">{{ slotProps.option.transcnpj }}</span>
                          <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submittedBase && !freteCotaBaseBaseData.fretecotabase_id">
                      <span class="text-danger font-size-11">Campo Base obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>



              </div>

              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormBase = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>

                  <b-button variant="outline-danger"
                            v-if="freteCotaBaseBaseData.id > 0"
                            @click="deletarBase" >
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Excluir
                  </b-button>

                  <b-button type="button" variant="success" class="ms-1" @click="confBase">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>



     




  </Layout>
</template>
